import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 1h8v2H8V1Zm14 4H2v2h3v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7h3V5ZM7 7h10v12H7V7Zm2 3.947L9.947 10 12 12.053 14.053 10l.947.947L12.947 13 15 15.053l-.947.947L12 13.947 9.947 16 9 15.053 11.053 13 9 10.947Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }